import cloneDeepWith from 'lodash.clonedeepwith';

const customizer = (value: any) => (typeof value === 'string' ? value.trim() : undefined);

export const withTrimmedValues = <T>(object: T): T => cloneDeepWith(object, customizer);
